import { useEffect, useState } from "react";
import { useFetcher } from "react-router-dom";

import { API_BASE_URL } from "../../config";
import Loader from "../../components/Loader";

export default function SearchSkillsOptions({
  handleCategories,
  handleCategoriesSearch,
  selectedJobTypes,
}) {
  const [query, setQuery] = useState("");
  const [isJobTypeSelected, setIsJobTypeSelected] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [jobTypes, setJobTypes] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [noResults, setNoResults] = useState(false);

  useEffect(() => {
    const fetchJobTypes = async () => {
      try {
        setIsLoading(true);
        const response = await fetch(`${API_BASE_URL}/job-types`);

        if (!response.ok) {
          throw new Error("Failed to fetch job types");
        }

        const data = await response.json();
        setJobTypes(data.data);
      } catch (error) {
        console.error("Error fetching job types:", error.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchJobTypes();
  }, []);

  const handleSkillChange = function (event) {
    const selectedJobTypeID = event.target.value;
    handleCategories(selectedJobTypeID);

    checkIfJobTypeSelected();
  };

  const handleSkillSearch = async (event) => {
    if (event.key === "Enter") {
      event.preventDefault();

      handleCategoriesSearch("");

      if (query.trim() === "") {
        setSearchResults([]);

        setNoResults(false);
        return;
      }

      setIsLoading(true);
      handleCategories("");

      const dataQuery = {
        query: query,
      };

      try {
        const response = await fetch(`${API_BASE_URL}/search-job-skills`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(dataQuery),
        });

        if (!response.ok) {
          if (response.status === 404) {
            setSearchResults([]);
            setNoResults(true);
          }
          throw new Error("Failed to fetch search results");
        }

        const data = await response.json();

        if (!data.data || data.data.length === 0) {
          setSearchResults([]);
          setNoResults(true);
        } else {
          setSearchResults(data.data);
          setNoResults(false);
        }
      } catch (error) {
        console.error("Error fetching search results:", error.message);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const checkIfJobTypeSelected = () => {
    const checked = document.querySelector("input[name='job_types']:checked");
    setIsJobTypeSelected(!!checked);
  };

  return (
    <>
      <div className="search-skills__input">
        <input
          type="text"
          placeholder="Search For Skills"
          onChange={(e) => setQuery(e.target.value)}
          value={query}
          onKeyDown={handleSkillSearch}
        />
      </div>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="search-skills__label--wrapper">
          <input
            type="hidden"
            value={selectedJobTypes.join(",")}
            readOnly
            name="job_types"
          />
          {noResults ? (
            <p>No results found.</p>
          ) : (
            (searchResults.length > 0 ? searchResults : jobTypes).map(
              (curr, index) => (
                <label className={`label-custom-all`} key={curr.id}>
                  <input
                    type="radio"
                    name="job_type_single"
                    value={curr.id}
                    onChange={handleSkillChange}
                  />
                  <span
                    className={` ${
                      selectedJobTypes.includes(String(curr.id)) ? "active" : ""
                    }`}
                  >
                    {curr.name}
                  </span>
                </label>
              )
            )
          )}
        </div>
      )}
    </>
  );
}
